// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { ILabel, IFormRegion, ITag } from "../../../../models/applicationState";
import { FontIcon } from "@fluentui/react";

export interface ITagInputItemLabelProps {
    label: ILabel;
    tag?: ITag;
    value: IFormRegion[];
    isOrigin: boolean;
    onLabelEnter?: (label: ILabel) => void;
    onLabelLeave?: (label: ILabel) => void;
    prefixText?: string;
    onLabelEdit: (label: ILabel) => void;
    onResetClick: (label: ILabel) => void;
    widgetMode?: boolean;
    isV3?: boolean;
    status?: string;
}

export interface ITagInputItemLabelState {}

export default function TagInputItemLabel(props: ITagInputItemLabelProps) {
    const {
        label,
        onLabelEnter,
        onLabelLeave,
        value,
        onLabelEdit,
        onResetClick,
    } = props;

    const texts = [];
    let hasEmptyTextValue = false;
    value?.forEach((formRegion: IFormRegion, idx) => {
        if (formRegion.text == "") {
            hasEmptyTextValue = true;
        } else {
            texts.push(formRegion.text);
        }
    });

    // const text = texts.join(" ");
    let text = "";
    if (props.isV3) { 
        const allHaveMoreThanOneWord = texts.every(item => item.trim().split(/\s+/).length > 1);
        const allAreEqual = texts.every(item => item === texts[0]);
        if (allHaveMoreThanOneWord && allAreEqual) { 
            text = texts[0];
        }        
        else {
            text = texts.join(" ");    
        }
    }
    else {
        text = texts.join(" ");
    }

    const handleMouseEnter = () => {
        if (props.onLabelEnter) {
            onLabelEnter(label);
        }
    };

    const handleMouseLeave = () => {
        if (props.onLabelLeave) {
            onLabelLeave(label);
        }
    };

    const handleEdit = (e) => {
        if (props.status && props.status.toLowerCase() === "completed") {
            return;
        }
        if (onLabelEdit) {
            onLabelEdit(label);
        }
        e.stopPropagation();
    };

    const copyClick = (e) => {
        if (!props.label && props.label.value.length === 0) {
            return;
        }

        const el = document.createElement("textarea");
        const text = props.label.value.map((x) => x.text).join(" ");
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        alert("Copied!");
        e.stopPropagation();
    };

    const resetClick = (e) => {
        if (props.status && props.status.toLowerCase() === "completed") {
            return;
        }
        if (onResetClick) {
            onResetClick(label);
        }
        e.stopPropagation();
    };

    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={[
                props.isOrigin ? "tag-item-label-origin" : "tag-item-label",
                "flex-center",
                "px-2",
            ].join(" ")}
        >
            <div className="flex-center" style={{ width: "70%" }}>
                {text ? props.prefixText : undefined} {text}
            </div>
            <div
                className="flex-right"
                style={{
                    marginLeft: "10px",
                    position: "absolute",
                    right: "10px",
                }}
            >
                {!hasEmptyTextValue && (
                    <FontIcon
                        className="mr-2"
                        iconName="edit"
                        title="Edit tag value"
                        onClick={handleEdit}
                        style={{
                            color: "#eeba57",
                        }}
                    />
                )}
                {!hasEmptyTextValue && (
                    <FontIcon
                        iconName="copy"
                        className="mr-2"
                        title="Copy tag value"
                        style={{
                            color: "#7fd27f",
                        }}
                        onClick={copyClick}
                    />
                )}
                {!hasEmptyTextValue && (
                    <FontIcon
                        style={{
                            color: "#ee6565",
                        }}
                        iconName="delete"
                        title="Delete tag value"
                        onClick={resetClick}
                    />
                )}
            </div>
        </div>
    );
}
